/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Ignore_Aria_LabelInputs */

const en_style_guide_ignore_aria_label = /** @type {(inputs: Style_Guide_Ignore_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignore Event`)
};

const fr_style_guide_ignore_aria_label = /** @type {(inputs: Style_Guide_Ignore_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorer l'evenement`)
};

const de_style_guide_ignore_aria_label = /** @type {(inputs: Style_Guide_Ignore_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignis ignorieren`)
};

const it_style_guide_ignore_aria_label = /** @type {(inputs: Style_Guide_Ignore_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignora evento`)
};

const ru_style_guide_ignore_aria_label = /** @type {(inputs: Style_Guide_Ignore_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Игнорировать событие`)
};

const es_style_guide_ignore_aria_label = /** @type {(inputs: Style_Guide_Ignore_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorar evento`)
};

const zh_cn2_style_guide_ignore_aria_label = /** @type {(inputs: Style_Guide_Ignore_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`忽略事件`)
};

const ja_style_guide_ignore_aria_label = /** @type {(inputs: Style_Guide_Ignore_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントを無視`)
};

const hi_style_guide_ignore_aria_label = /** @type {(inputs: Style_Guide_Ignore_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घटना को अनदेखा करें`)
};

const pt_pt2_style_guide_ignore_aria_label = /** @type {(inputs: Style_Guide_Ignore_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorar evento`)
};

/**
* | output |
* | --- |
* | "Ignore Event" |
*
* @param {Style_Guide_Ignore_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_ignore_aria_label = /** @type {((inputs?: Style_Guide_Ignore_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Ignore_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_ignore_aria_label(inputs)
	if (locale === "de") return de_style_guide_ignore_aria_label(inputs)
	if (locale === "it") return it_style_guide_ignore_aria_label(inputs)
	if (locale === "ru") return ru_style_guide_ignore_aria_label(inputs)
	if (locale === "es") return es_style_guide_ignore_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_ignore_aria_label(inputs)
	if (locale === "ja") return ja_style_guide_ignore_aria_label(inputs)
	if (locale === "hi") return hi_style_guide_ignore_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_ignore_aria_label(inputs)
	return en_style_guide_ignore_aria_label(inputs)
});